// extracted by mini-css-extract-plugin
module.exports = {"notesListContainer":"NotesList_notesListContainer__HOvUN","emptyNotesContainer":"NotesList_emptyNotesContainer__AVvkg"};